export const requestNotificationPermission = () =>
	new Promise<NotificationPermission>((resolve, reject) => {
		if (!('Notification' in window)) {
			reject(new Error('This browser does not support desktop notification'));
		} else {
			try {
				resolve(window.Notification.requestPermission());
			} catch (err) {
				// Safari doesn't return a promise for requestPermissions and it
				// throws a TypeError. It takes a callback as the first argument
				// instead.
				if (err instanceof TypeError) {
					Notification.requestPermission(resolve);
				} else {
					reject(err);
				}
			}
		}
	});
